import { useEffect } from "react";
import { About } from "@/components/About";
import { AirportsMap } from "@/components/AirportsMap";
import { Footer } from "@/components/Footer";
import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { Payments } from "@/components/Payments";
import { QuoteForm } from "@/components/QuoteForm";
import { Rahalty } from "@/components/Rahalty";
import { Services } from "@/components/Services";
import { StatsBar } from "@/components/StatsBar";

export default function Home() {
  useEffect(() => {
    if (window.location.hash) {
      const id = window.location.hash.slice(1);
      const timer = setTimeout(() => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" }), 400);
      return () => clearTimeout(timer);
    }
  }, []);

  return (
    <div className="min-h-screen bg-[#060B14]" data-testid="home-page">
      <Header />
      <main>
        <Hero />
        <StatsBar />
        <Marquee />
        <Services />
        <AirportsMap />
        <About />
        <Rahalty />
        <QuoteForm />
        <Payments />
      </main>
      <Footer />
    </div>
  );
}
